import VoucherStatusType from "Enum/voucherStatusType";
import jwtDecode from 'jwt-decode'

/**
 * Convert number to money
 * @param {*} number
 */
const convertFormatNumberToMoney = function (number) {
    return Number(number).toFixed(0).replace(/./g, function (c, i, a) {
        return i > 0 && c !== '.' && (a.length - i) % 3 === 0 ? '.' + c : c
    })
}
/**
 * Check null
 * @param {*} data
 */
const isNull = function (data) {
    if (data === undefined || data === null) {
        return true
    } else {
        return false
    }
}
const errorResponse = function (response) {
  return isNull(response.data.message) ? 'server.common.error' : response.data.message
}
const decodeJwtResponse = function (data) {
    return !isEmptyString(data) ? jwtDecode(data) : null
}
/**
 * Get first name and last name from full name
 * @param {*} fullName
 */
const getFirstLastName = function (fullName) {
    let firstName = ''
    let lastName = ''
    if (!isNull(fullName) && fullName != '') {
        // Split full name to get last name and first name
        let fullNameArray = fullName.split(' ')
        firstName = fullNameArray[fullNameArray.length - 1]
        for (let i = 0, size = fullNameArray.length - 1; i < size; i++) {
            lastName += fullNameArray[i] + (i < size - 1 ? ' ' : '')
        }
    }
    return {
        'firstName': firstName,
        'lastName': lastName
    }
}
/**
 * Remove space in string
 * @param {*} str
 */
const removeSpaceInString = function (str) {
    return str.replace(/\s/g, '')
}

/**
 * Validate email
 * @param {*} email
 */
const validateEmail = function (email) {
    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
}

const validatePhone = function (phone) {
    const regex = /^(0[3|5|7|8|9][0-9]{8}|[+]84[3|5|7|8|9][0-9]{8})$/
    return !!regex.test(phone)
}

const validateDateOfBirth = function (date) {
    var regex = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/
    return !!regex.test(date)
}

/**
 * Check empty string
 * @param {*} value 
 */
const isEmptyString = function (value) {
    return (value === undefined) || (value === null) || (typeof value === 'string' && value.trim().length === 0)
}

const validateStringIsNull = function (value) {
    if (value == null) {
        return true
    } else {
        return isEmptyString(value)
    }
}

const removeDoubleSlashesFromUrl = function (url) {
    return String(url).replace(/([^:]\/)\/+/g, "$1");
}

const concatFullname = function (lastname, firstname, defValue = '') {
    if (!isEmptyString(firstname) && !isEmptyString(lastname)) {
      return lastname + ' ' + firstname
    } else if (!isEmptyString(firstname)) {
      return firstname
    } else if (!isEmptyString(lastname)) {
      return lastname
    }
    return defValue
}

const concatFullAddress = function (addressInfo, street) {
    var fullAddress = street
    if (addressInfo.ward.type || addressInfo.ward.name) {
        if (!isEmptyString(fullAddress)) {
            fullAddress += ', ' + addressInfo.ward.type + ' ' + addressInfo.ward.name
        } else {
            fullAddress = addressInfo.ward.type + ' ' + addressInfo.ward.name
        }
    }
    if (addressInfo.district.type || addressInfo.district.name) {
        if (!isEmptyString(fullAddress)) {
            fullAddress += ', ' + addressInfo.district.type + ' ' + addressInfo.district.name
        } else {
            fullAddress = addressInfo.district.type + ' ' + addressInfo.district.name
        }
    }
    if (addressInfo.city.type || addressInfo.city.name) {
        if (!isEmptyString(fullAddress)) {
            fullAddress += ', ' + addressInfo.city.type + ' ' + addressInfo.city.name
        } else {
            fullAddress = addressInfo.city.type + ' ' + addressInfo.city.name
        }
    }
    if (!isEmptyString(fullAddress) && addressInfo.country.name) {
        fullAddress += ', ' + addressInfo.country.name
    }
    return fullAddress
}

const getVoucherStatusText = function(status) {
    if (!isNull(status)) {
        if (status === VoucherStatusType.INACTIVE) {
            return 'evoucher.status.inactive'
        } else if (status === VoucherStatusType.USING_EXPIRED) {
            return 'evoucher.status.using_expired'
        } else if (status === VoucherStatusType.ACTIVATED) {
            return 'evoucher.status.activated'
        } else if (status === VoucherStatusType.USED) {
            return 'evoucher.status.used'
        } else if (status === VoucherStatusType.DISTRIBUTION_EXPIRED) {
            return 'evoucher.status.distribution_expired'
        } else if (status === VoucherStatusType.LOCKED_USING) {
            return 'evoucher.status.locked'
        } else if (status === VoucherStatusType.WAITING) {
            return 'evoucher.status.waiting'
        }
        return 'Unknown ' + status
    }
    return ''
}

const ellipsisLongText = function (strText, len) {
    if (!isNull(strText) && strText.length > len) {
      const truncate = (str, len) => str.substring(0, (str + ' ').lastIndexOf(' ', len))
      return truncate(strText, len) + '...'
    }
    return strText
}

const randomString = (length = 8) => {
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    let str = ''
    for (let i = 0; i < length; i++) {
      str += chars.charAt(Math.floor(Math.random() * chars.length))
    }
    return str
}

export default {
    isNull,
    errorResponse,
    decodeJwtResponse,
    getFirstLastName,
    removeSpaceInString,
    convertFormatNumberToMoney,
    validateEmail,
    validatePhone,
    validateDateOfBirth,
    validateStringIsNull,
    removeDoubleSlashesFromUrl,
    concatFullname,
    concatFullAddress,
    getVoucherStatusText,
    ellipsisLongText,
    randomString
}